export default class ToolUseComponent {
    private container: HTMLElement;
    private toolName: string;
    private status: 'loading' | 'success' | 'error';
    private toolUseBlock?: any;
    private toolError?: string;

    constructor(container: HTMLElement, toolName: string, status: 'loading' | 'success' | 'error' = 'loading', toolUseBlock?: any) {
        this.container = container;
        this.toolName = toolName;
        this.status = status;
        this.toolUseBlock = toolUseBlock;
        this.renderHTML();
    }

    public generateHtmlContent(): string {
        const statusText = this.status === 'loading' ? `Calculating ${this.toolName}...` : this.status === 'success' ? `<svg style="margin-right:.5rem" height="18" width="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" stroke="#05A862" stroke-width="2" fill="none"></circle><path d="M16.707 8.707a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l4.293-4.293a1 1 0 0 1 1.414 0z" fill-rule="evenodd" fill="#05A862"></path></svg> Finished ${this.toolName} tool` : `Error on ${this.toolName} tool`;
        const textClass = this.status === 'loading' ? 'loading-shimmer' : '';

        return `
        <div class="tooluse-component ${this.status}" style="margin-bottom: 1rem;">
            <div class="collapsible">
                <span style="display:flex" class="${textClass}">${statusText}${this.status === 'success' && this.toolUseBlock ? `` : ''}</span>
            </div>
            ${this.status === 'loading' ? '' : ''}
            ${this.status === 'success' && this.toolUseBlock ? this.getHTMLForInput() : ''}
            ${this.status === 'error' ? `<div class="tooluse-error collapsibleContent" style="color: red;">${this.toolError}</div>` : ''}
        </div>
    `.replace(/\s\s+/g, '').trim();
    }

    private getHTMLForInput(): string {
        if (this.toolUseBlock && this.toolUseBlock.input) {
            const inputs = this.toolUseBlock.input;
            let html = '<div class="collapsibleContent" style="margin-top:.5rem; border-radius:5px;color:#b4b4b4">' +
                '<div style="background:#202029; border: 1px solid #383737; padding: .3rem .8rem; display: flex; font-size: .8rem;">Passed inputs for tool</div>';

            for (const key in inputs) {
                if (inputs.hasOwnProperty(key)) {
                    const value = inputs[key];
                    if (typeof value === 'object') {
                        html += `<div style="padding: .5rem .8rem;border: 1px solid #383737; border-top: none; display: flex;"><span>${key}:</span><span style="color:#FFF; margin-left:.3rem">${JSON.stringify(value)}</span></div>`;
                    } else {
                        html += `<div style="padding: .5rem .8rem;border: 1px solid #383737; border-top: none; display: flex;"><span>${key}:</span><span style="color:#FFF; margin-left:.3rem">${value}</span></div>`;
                    }
                }
            }

            html += '</div>';
            return html;
        }
        return '';
    }

    private renderHTML() {
        this.container.innerHTML = this.generateHtmlContent();
    }
}